import React, { PureComponent } from 'react';
import ReactPaginate from 'react-paginate';
import $ from 'jquery';

export class UserReview extends PureComponent {
  constructor(props){
    super(props);
    this.state = { reviews: [], page: 1 };
  }

  getReviews(){
    const { url } = this.props;
    $.ajax({
      url: url,
      data: { page: this.state.page },
      dataType: 'json',
      type: 'GET',

      success: data => {
        this.setState({ reviews: data.results });
      },

      error: (xhr, status, err) => {
        console.error(url, status, err.toString());
      }
    });
  }

  handlePageClick = (data) => {
    let selected = data.selected;
    this.setState({ page: ++selected }, () => {
      this.getReviews();
    });
  };


  componentWillMount(){
    this.getReviews();
  }

  render() {
    const { reviews } = this.state;
    let paginate = <div className="loading">Loading..</div>
    if (this.props.pageCount === 0)
      paginate = <div className="no-reviews">No reviews yet.</div>
    if (this.props.pageCount > 0){
      if (reviews.length > 5) {
        paginate = <ReactPaginate previousLabel={"previous"}
        nextLabel={"next"}
        breakLabel={<a href="">...</a>}
        breakClassName={"break-me"}
        pageCount={this.props.pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={this.handlePageClick}
        containerClassName={"row nav navbar discover-navbar"}
        subContainerClassName={"pages pagination"}
        activeClassName={"active"} />
      } else if (reviews.length > 0 && reviews.length <= 5){
        paginate = null;
      }
    }

    return (
      <div>
        { reviews.map((review) => {
          return (
            <div className={`profile--review-item ${review.status}`} key={review.id}>
              <div className='album-item d-flex'>
                <div className='review-image'>
                  <img src={review.album_image} alt={review.album_title}/>
                </div>
                <div className='review-details'>
                  { review.status === 'unapproved' && <span className="status-label">Your review is awaiting approval.</span> }
                  <div className='review-name'>{review.album_artist}</div>
                  <div className='review-title'>
                    <a href={review.album_path}>{review.album_title}</a>
                  </div>
                </div>
              </div>
              {review.unapproved && (
                <label className='alert-info'>Your review is awaiting approval.</label>
              )}
              <div className='review-description'>
                <p className='review-body'>{review.description}</p>
                <div className='row'>
                  <div className='col-md-6'/>
                  <div className='col-md-6'>
                    <div className='review-time'>
                      {review.time_ago}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        { paginate }
      </div>
    )
  }
}